import { render, staticRenderFns } from "./CityStation.vue?vue&type=template&id=267f877a&scoped=true&"
import script from "./CityStation.vue?vue&type=script&lang=js&"
export * from "./CityStation.vue?vue&type=script&lang=js&"
import style0 from "./CityStation.vue?vue&type=style&index=0&id=267f877a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267f877a",
  null
  
)

export default component.exports